// The arrows of the keyboard must keep working in an input (comment, search…).
const isTyping = (target: EventTarget | null) => {
  const el = target as HTMLElement | null;
  if (!el) {
    return false;
  }
  return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable;
};

export { isTyping };
